// extracted by mini-css-extract-plugin
export default {"baseContainer":"DataRow_baseContainer__eeW4D","containerMobile":"DataRow_containerMobile__jrKwp","container":"DataRow_container__RGm3O","title":"DataRow_title__aC0of"};